/* (function () {
	const header = () => {
		const megaMenuLinks = document.querySelectorAll(".list-menu--megamenu");
		megaMenuLinks.forEach((link) => {
			link.addEventListener("mouseenter", () => {
				link.classList.add("list-menu--megamenu-visible");

				link.addEventListener("mousemove", () => {
					link.classList.add("list-menu--megamenu-visible");
				});

				link.addEventListener("mouseleave", () => {
					link.classList.remove("list-menu--megamenu-visible");
					link.addEventListener("mouseenter", () => {
						link.classList.add("list-menu--megamenu-visible");
					});
				});
			});
		});
	};

	document.addEventListener("shopify:section:load", header);

	header();
})();
 */
// Updated to a more robust and accessible approach, but keeping the old code in case we want to revert or reference it.
(function () {
  const TOGGLE_SELECTOR = ".header__submenu-toggle";
  const BACK_SELECTOR = ".menu-drawer__close-button";

  // Important: include desktop-level menu containers so we can close siblings on desktop.
  const MENU_SCOPE_SELECTOR =
    ".menu-drawer__menu, .header__inline-menu, .list-menu--inline, .header__submenu";

  function isInDrawer(el) {
    return !!el.closest(".menu-drawer");
  }

  function getControlledMenu(toggle) {
    const id = toggle.getAttribute("aria-controls");
    return id ? document.getElementById(id) : null;
  }

  function closeDescendants(container) {
    if (!container) return;
    const openToggles = container.querySelectorAll(
      `${TOGGLE_SELECTOR}[aria-expanded="true"]`
    );
    openToggles.forEach((t) => closeMenu(t));
  }

  function openMenu(toggle) {
    toggle.setAttribute("aria-expanded", "true");
    const menu = getControlledMenu(toggle);
    if (menu) menu.hidden = false;

    // Keep Stockmart mega-menu class behavior (desktop)
    const megaLi = toggle.closest(".list-menu--megamenu");
    if (megaLi) megaLi.classList.add("list-menu--megamenu-visible");
  }

  function closeMenu(toggle) {
    toggle.setAttribute("aria-expanded", "false");
    const menu = getControlledMenu(toggle);
    if (menu) {
      // Close any open nested toggles inside this submenu too
      closeDescendants(menu);
      menu.hidden = true;
    }

    const megaLi = toggle.closest(".list-menu--megamenu");
    if (megaLi) megaLi.classList.remove("list-menu--megamenu-visible");
  }

  function closeAll(root) {
    const openToggles = (root || document).querySelectorAll(
      `${TOGGLE_SELECTOR}[aria-expanded="true"]`
    );
    openToggles.forEach(closeMenu);
  }

  function closeSiblingsInSameScope(toggle) {
    // Find the nearest menu list (level) that contains this toggle
    const scope = toggle.closest(MENU_SCOPE_SELECTOR);
    if (!scope) return;

    const openToggles = scope.querySelectorAll(
      `${TOGGLE_SELECTOR}[aria-expanded="true"]`
    );

    openToggles.forEach((t) => {
      if (t !== toggle) closeMenu(t);
    });
  }

  function handleBackButtonClick(backBtn) {
    // Back buttons live inside the submenu they're meant to close
    const submenu = backBtn.closest(".menu-drawer__submenu, .header__submenu");
    if (!submenu || !submenu.id) return;

    // Find the toggle that controls this submenu
    const controllingToggle = document.querySelector(
      `${TOGGLE_SELECTOR}[aria-controls="${CSS.escape(submenu.id)}"]`
    );

    if (controllingToggle) closeMenu(controllingToggle);
    else submenu.hidden = true;
  }

  function initHeaderA11yMenus() {
    if (document.documentElement.dataset.a11yHeaderMenusInit === "1") return;
    document.documentElement.dataset.a11yHeaderMenusInit = "1";

    // Ensure hidden always wins
    document
      .querySelectorAll(".header__submenu[hidden], .menu-drawer__submenu[hidden]")
      .forEach((m) => (m.hidden = true));

    // Click handling (CAPTURE) so theme drawer scripts don't intercept first
    document.addEventListener(
      "click",
      (e) => {
        const backBtn = e.target.closest(BACK_SELECTOR);
        if (backBtn) {
          e.preventDefault();

          // Only block bubbling in the drawer (prevents the whole drawer closing)
          if (isInDrawer(backBtn)) {
            e.stopPropagation();
            if (typeof e.stopImmediatePropagation === "function") {
              e.stopImmediatePropagation();
            }
          }

          handleBackButtonClick(backBtn);
          return;
        }

        const toggle = e.target.closest(TOGGLE_SELECTOR);

        if (toggle) {
          e.preventDefault();

          // Only block bubbling in the drawer (prevents the whole drawer closing)
          if (isInDrawer(toggle)) {
            e.stopPropagation();
            if (typeof e.stopImmediatePropagation === "function") {
              e.stopImmediatePropagation();
            }
          }

          // Desktop: close siblings. Drawer: keep siblings open to avoid big jumps.
          if (!isInDrawer(toggle)) {
            closeSiblingsInSameScope(toggle);
          }

          const isOpen = toggle.getAttribute("aria-expanded") === "true";
          isOpen ? closeMenu(toggle) : openMenu(toggle);
          return;
        }

        // Optional: click outside closes all open desktop dropdowns.
        // If you want this, uncomment:
         closeAll();
      },
      true // capture phase
    );

    // Keyboard: Enter/Space toggles, Escape closes
    document.addEventListener(
      "keydown",
      (e) => {
        const toggle = e.target.closest ? e.target.closest(TOGGLE_SELECTOR) : null;

        if ((e.key === "Enter" || e.key === " ") && toggle) {
          e.preventDefault();

          if (isInDrawer(toggle)) {
            e.stopPropagation();
            if (typeof e.stopImmediatePropagation === "function") {
              e.stopImmediatePropagation();
            }
          }

          // Desktop: close siblings. Drawer: keep siblings open.
          if (!isInDrawer(toggle)) {
            closeSiblingsInSameScope(toggle);
          }

          const isOpen = toggle.getAttribute("aria-expanded") === "true";
          isOpen ? closeMenu(toggle) : openMenu(toggle);
          return;
        }

        if (e.key === "Escape") {
          const openToggle = document.querySelector(
            `${TOGGLE_SELECTOR}[aria-expanded="true"]`
          );
          if (openToggle) {
            closeMenu(openToggle);
            openToggle.focus();
          }
        }
      },
      true // capture phase
    );
  }

  document.addEventListener("shopify:section:load", initHeaderA11yMenus);
  initHeaderA11yMenus();
})();